import { CheckName } from 'dashboard/models/check/check';
import { RiskConfigCheckConfig } from 'dashboard/models/verification-check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export type SelfieAgeThresholdCheckName = CheckName.SelfieAgeThresholdComparison;

export interface SelfieAgeThresholdComparisonCheckConfig extends RiskConfigCheckConfig {
  check: SelfieAgeThresholdCheckName;
  'age-limit': {
    'min-age'?: number | null;
    'max-age'?: number | null;
  } | null;
}

export function isSelfieAgeThresholdCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is SelfieAgeThresholdComparisonCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.SelfieAgeThresholdComparison:
      return true;
    default:
      return false;
  }
}
